<template>
    <div
        :class="[styles.card, {
        'transition duration-300 ease-out lg:group-hover:translate-x-4': anim && interactive,
        'mx-auto sm:w-11/12 md:max-w-xl': size === 'sm'
      }]"
        class="lg:h-full"
        tabindex="0"
    >
        <div v-if="img !== undefined && img !== null">
            <img
                :src="img"
                class="w-full"
            >
        </div>
        <div
            :class="[size === 'sm' ? 'justify-center' : 'justify-between']"
            class="lg:flex"
        >
            <BaseH2
                v-if="title !== undefined"
                class="my-2 underline"
            >
                {{ title }}
            </BaseH2>
            <div v-else></div>
            <div class="flex">
                <slot name="actions"></slot>
            </div>
        </div>
        <slot/>
    </div>
</template>

<script>
import BaseH2 from './Titles/BaseH2'

export default {
  name: 'BaseCard',
  components: { BaseH2 },
  props: {
    title: {
      type: String
    },

    img: String,

    interactive: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'lg',
      validator (value) {
        return [
          'lg', 'sm'
        ].includes(value)
      }
    }
  },
  data () {
    return {
      styles: window.myStyles,
      anim: window.anim
    }
  }
}
</script>

<style scoped>

</style>
